<template>
	<v-container grid-list-xl pa-0>
		<v-layout column>
			<v-flex>
				<v-btn
					flat
					class="ma-0 mt-3"
					color="success"
					@click="addItem"
				>
					Add Option
				</v-btn>
			</v-flex>
			
			<v-flex v-if="items.length > 0">
				<draggable
					class="draggable mt-3"
					:list="items"
					@change="reorderItems"
				>
					<v-card
						v-for="item in items"
						:key="item.id"
						class="mb-4"
					>
						<v-container
							fluid
							grid-list-xl
							px-3
							py-0
						>
							<v-layout
								row
								align-center
								justify-space-between
								py-2
							>
								<v-flex
									xs12
									class="py-0"
								>
									<div class="subheading">
										<v-icon
											small
											class="mr-2"
										>
											fa-sort
										</v-icon>
										{{ item.label }}
									</div>
								</v-flex>
								<v-flex
									v-if="canEdit"
									class="d-flex pa-0"
								>
									<v-btn
										class="ma-0 mr-1"
										flat
										icon
										small
										color="primary"
										@click="updateItem(item)"
									>
										<v-icon>edit</v-icon>
									</v-btn>
									<v-btn
										class="ma-0"
										flat
										icon
										small
										color="error"
										@click="deleteItem(item)"
									>
										<v-icon>delete</v-icon>
									</v-btn>
								</v-flex>
							</v-layout>
						</v-container>
					</v-card>
				</draggable>
			</v-flex>
		
			<v-dialog
				v-model="showItemForm"
				max-width="800"
			>
				<v-card>
					<v-container grid-list-xl>
						<CustomFieldItemForm
							:custom-field="customField"
							:item="itemToEdit"
							@close="createdOrUpdated"
						/>
					</v-container>
				</v-card>
			</v-dialog>
			
		</v-layout>
	</v-container>
</template>

<script>
import draggable from 'vuedraggable';
import axios from '@/util/axios';
import { CustomDataItems } from '@/models/CustomData';
import CustomFieldItemForm from '@/components/Project/CustomFields/CustomFieldItemForm';

export default {
	components: {
		draggable,
		CustomFieldItemForm,
	},
	
	props: {
		customField: {
			type: Object,
			default: null,
		},
	},
	
	data() {
		return {
			showItemForm: false,
			itemToEdit: null,
		};
	},
	
	computed: {
		project() {
			return this.$store.get('projects/currentProject');
		},
		
		canEdit() {
			return this.project.userCan('manage_custom_data') && !this.project.isArchived;
		},
		
		items() {
			return this.customField.items.models;
		},
	},
	
	methods: {
		addItem() {
			this.showItemForm = true;
			this.itemToEdit = null;
		},
		
		updateItem(item) {
			this.showItemForm = true;
			this.itemToEdit = item;
		},
		
		deleteItem(item) {
			console.log('deleting item disabled');
			return;
			const name = item.label;

			this.$refs.confirm.createConfirm(`This will delete "${name}".`, 'error').then((answer) => {
				if (!answer) {
					return;
				}
				item.delete().then(() => {
					this.refetchItems();
					this.$notify('success', `Field "${name}" has been deleted.`);
				}).catch(() => {
					this.$notify('error', `Failed to delete field "${name}".`);
				});
			});
		},
		
		createdOrUpdated() {
			this.showItemForm = false;
			this.refetchItems();
		},
		
		refetchItems() {
			const customDataItems = new CustomDataItems();
			customDataItems.set('parentId', this.customField.id);
			customDataItems.fetch().then(() => {
				customDataItems.sort('order');
				this.customField.items = customDataItems;
			}).catch((e) => {
				dump(e);
				this.customField.items = new CustomDataItems();
				this.$notify('error', `Failed to fetch ${this.customField.label} options`);
			});
		},
		
		reorderItems() {
			const data = {
				parentId: this.customField.id,
				order: this.items.map(item => item.value),
			};
			
			axios.post('/custom-data-items/reorder', data).then().catch((e) => {
					dump('Custom data items reorder error', e);
					this.$notify('error', `Failed to reorder ${this.customField.label} options.`);
				}).finally(() => {
					this.refetchItems();
				});
		},
	},
}
</script>
